const MAX_COLUMN_LIMIT = 1500;

export { MAX_COLUMN_LIMIT };
